module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-result private"
  }, [_c('div', {
    staticClass: "order-result-block-1 private"
  }, [_c('div', {
    staticClass: "order-result-block-1__col"
  }, [_vm._m(0), _vm._v(" "), (_vm.subscriptionType) ? _c('edit-private') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-result-block-1__link-container private"
  }, [_c('a', {
    staticClass: "order-result-block-1__link-info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePriceSummaryModalVisible.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    Preiszusammenstellung\n                ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-result-block-1__text-container text-container"
  }, [_c('h2', {
    staticClass: "order-section__heading"
  }, [_vm._v("4. Lieferung")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21df6498","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/ResultsPrivate.vue
// module id = 771
// module chunks = 0